import { css } from 'linaria';

export const SEASON_START_HOUSE_PATH = '/promo/pora-pora-dom/';

export const SEASON_START_HOUSE_ELEMENT_BLOCK = 'landingStartSezonaDom';

export const SEASON_START_HOUSE_CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/season-start-house';

export const SEASON_START_HOUSE_LANDING_NAME = 'season-start-house';

export const SEASON_START_HOUSE_PRODUCTS = [
  {
    link: {
      href: '/offer/pora-pora-za-kondicionerami-po-supercenam',
      title: 'Кондиционеры с установкой',
    },
    img: {
      alt: 'Баннер Кондиционеры с установкой',
      srcD: `${SEASON_START_HOUSE_CDN_PATH}/banners/air-conditioners-banner-ld.jpg/air-conditioners-banner-ld-02.jpg`,
      srcT: `${SEASON_START_HOUSE_CDN_PATH}/banners/air-conditioners-banner-t.jpg/air-conditioners-banner-t-02.jpg`,
      src: `${SEASON_START_HOUSE_CDN_PATH}/banners/air-conditioners-banner-m.jpg/air-conditioners-banner-m-02.jpg`,
    }
  },
  {
    link: {
      href: '/offer/pora-pora-za-mezhkomnatnymi-dveryami-po-supercenam',
      title: 'Межкомнатные двери с установкой',
    },
    img: {
      alt: 'Баннер Межкомнатные двери с установкой',
      srcD: `${SEASON_START_HOUSE_CDN_PATH}/banners/interior-doors-baner-ld.jpg/interior-doors-baner-ld-01.jpg`,
      srcT: `${SEASON_START_HOUSE_CDN_PATH}/banners/interior-doors-baner-t.jpg/interior-doors-baner-t-01.jpg`,
      src: `${SEASON_START_HOUSE_CDN_PATH}/banners/interior-doors-baner-m.jpg/interior-doors-baner-m-01.jpg`,
    }
  }
];

export const SEASON_START_HOUSE_SOLUTIONS = [
  {
    link: {
      href: '/promo/pora-pora-uchastok/',
      title: 'Облагородим участок',
    },
    img: {
      alt: 'Баннер Облагородим участок',
      srcD: `${SEASON_START_HOUSE_CDN_PATH}/banners/plot-banner-ld.jpg/plot-banner-ld-01.jpg`,
      srcT: `${SEASON_START_HOUSE_CDN_PATH}/banners/plot-banner-t.jpg/plot-banner-t-01.jpg`,
      src: `${SEASON_START_HOUSE_CDN_PATH}/banners/plot-banner-m.jpg/plot-banner-m-01.jpg`,
    }
  },
  {
    link: {
      href: '/promo/pora-pora-stroitelstvo/',
      title: 'Поможем построить',
    },
    img: {
      alt: 'Баннер Поможем построить',
      srcD: `${SEASON_START_HOUSE_CDN_PATH}/banners/construction-banner-ld.jpg/construction-banner-ld-01.jpg`,
      srcT: `${SEASON_START_HOUSE_CDN_PATH}/banners/construction-banner-t.jpg/construction-banner-t-01.jpg`,
      src: `${SEASON_START_HOUSE_CDN_PATH}/banners/construction-banner-m.jpg/construction-banner-m-01.jpg`,
    }
  },
];

export const SEASON_START_HOUSE_SOLUTIONS_CATEGORIES = [
  {
    discountBableSrc: `${SEASON_START_HOUSE_CDN_PATH}/categories/finishing-discount-babel.png/finishing-discount-babel.png`,
    img: {
      className: css`
        @media (--from-desktop) {
          height: 674px;
        }

        @media (--only-tablet) {
          height: 660px;
        }

        @media (--only-mobile) {
          height: 450px;
        }
      `,
      srcLd: `${SEASON_START_HOUSE_CDN_PATH}/categories/finishing-bg-ld.jpg/finishing-bg-ld.jpg`,
      srcD: `${SEASON_START_HOUSE_CDN_PATH}/categories/finishing-bg-d.jpg/finishing-bg-d.jpg`,
      srcT: `${SEASON_START_HOUSE_CDN_PATH}/categories/finishing-bg-t.jpg/finishing-bg-t.jpg`,
      src: `${SEASON_START_HOUSE_CDN_PATH}/categories/finishing-bg-m.jpg/finishing-bg-m.jpg`,
    },
    itemList: [
      {
        href: '/offer/pora-pora-za-oboyami-po-supercenam/',
        img: {
          alt: 'Изображение обоев',
          src: `${SEASON_START_HOUSE_CDN_PATH}/categories/wallpaper.jpg/wallpaper.jpg`,
        },
        title: 'Обои',
      },
      {
        href: '/offer/pora-pora-za-keramogranitom-po-supercenam/',
        img: {
          alt: 'Изображение керамогранита',
          src: `${SEASON_START_HOUSE_CDN_PATH}/categories/porcelain-stoneware.jpg/porcelain-stoneware.jpg`,
        },
        title: 'Керамогранит с укладкой',
      },
      {
        href: '/offer/pora-pora-za-polami-po-supercenam',
        img: {
          alt: 'Изображение ламината',
          src: `${SEASON_START_HOUSE_CDN_PATH}/categories/laminate.jpg/laminate.jpg`,
        },
        title: 'Ламинат с укладкой',
      },
    ],
    title: 'Отделка',
  },
  {
    discountBableSrc: `${SEASON_START_HOUSE_CDN_PATH}/categories/decor-discount-babel.png/decor-discount-babel.png`,
    img: {
      className: css`
        @media (--from-desktop) {
          height: 674px;
        }

        @media (--only-tablet) {
          height: 660px;
        }

        @media (--only-mobile) {
          height: 478px;
        }
      `,
      srcLd: `${SEASON_START_HOUSE_CDN_PATH}/categories/decor-bg-ld.jpg/decor-bg-ld.jpg`,
      srcD: `${SEASON_START_HOUSE_CDN_PATH}/categories/decor-bg-d.jpg/decor-bg-d.jpg`,
      srcT: `${SEASON_START_HOUSE_CDN_PATH}/categories/decor-bg-t.jpg/decor-bg-t.jpg`,
      src: `${SEASON_START_HOUSE_CDN_PATH}/categories/decor-bg-m.jpg/decor-bg-m-01.jpg`,
    },
    itemList: [
      {
        href: '/offer/pora-pora-za-tekstilem-i-aksessuarami-dlya-doma-po-supercenam',
        img: {
          alt: 'Изображение подушки',
          src: `${SEASON_START_HOUSE_CDN_PATH}/categories/textile.jpg/textile.jpg`,
        },
        title: 'Текстиль и аксессуары',
      },
      {
        href: '/offer/pora-pora-za-shtorami-i-karnizami-po-supercenam',
        img: {
          alt: 'Изображение штор',
          src: `${SEASON_START_HOUSE_CDN_PATH}/categories/curtains.jpg/curtains.jpg`,
        },
        title: 'Шторы и карнизы',
      },
      {
        href: '/offer/pora-pora-za-mebelyu-dlya-doma-po-supercenam',
        img: {
          alt: 'Изображение стула',
          src: `${SEASON_START_HOUSE_CDN_PATH}/categories/furniture.jpg/furniture-05.jpg`,
        },
        title: 'Мебель',
      },
    ],
    title: 'Декор\nи мебель',
  },
];
